import { createContext, useContext } from 'react'

// The table's toolbar row (TableAgClient, TableAgInfinite): the quick filter,
// and -- for a grid embedded in a section, which has no card header of its own
// (FleetGrid flush) -- the page's controls before it (`start`, e.g. a status
// select) and the grid's menu after it (`end`: export, table settings).
// Without a provider the row is the filter alone, as on every list page.
export const TableToolbarContext = createContext(null)

export const useTableToolbar = () => useContext(TableToolbarContext) || {}
